// extracted by mini-css-extract-plugin
export default {"container":"somethingWrong_container__sDkXt","message":"somethingWrong_message__WSbDG"};